import HttpService from './baseHttp'
// 基础数据


//管理仓配置分页查询
export const HttpManageWareList = (data = {}) => HttpService.get('/api/v2/warehouse/findByPage', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })
//管理仓配置单条查询
export const HttpManageWare = (data = {}) => HttpService.get('/api/v2/warehouse/findOne', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })
//管理仓配置客户分页查询
export const HttpManageWareCustomeList = (data = {}) => HttpService.get('/api/v2/warehouse/findOrgId', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })
//管理仓配置渠道分页查询
export const HttpManageWareChannelList = (data = {}) => HttpService.get('/api/v2/warehouse/findChannel', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })
//管理仓配置保存
export const HttpSaveManageWare = (data = {}) => HttpService.post('/api/v2/warehouse/saveOne', data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_FBB })
//管理仓配置导出
export const HttpExportManageWare = (data = {}, config) => HttpService.get('/api/v2/warehouse/export', { ...config, params: data, baseURL: process.env.VUE_APP_APIURL_FBB })


// 承运商配置
//承运商配置分页查询
export const HttpCarrierList = (data = {}) => HttpService.get('/api/v2/systemCarrier/findByPage', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })
//承运商配置单条查询
export const HttpCarrier = (data = {}) => HttpService.get('/api/v2/systemCarrier/findOne', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })
//承运商配置保存
export const HttpSaveCarrier = (data = {}) => HttpService.post('/api/v2/systemCarrier/saveOne', data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_FBB })
//所有承运商(有效)
export const HttpCarrierAllList = (data = {}) => HttpService.get('/api/v2/systemCarrier/findAllActive', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })

//所有承运商
export const HttpCarrierAll = (data = {}) => HttpService.get('/api/v2/systemCarrier/findAll', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })




// 承运商服务配置
//承运商服务配置分页查询
export const HttpCarrierServiceList = (data = {}) => HttpService.get('/api/v2/SystemDeliveryCarrier/findByPage', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })
//承运商服务单条查询
export const HttpCarrierService = (data = {}) => HttpService.get('/api/v2/SystemDeliveryCarrier/findOne', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })
//承运商服务客户分页查询
export const HttpCarrierServiceCustomeList = (data = {}) => HttpService.get('/api/v2/SystemDeliveryCarrier/findOrgId', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })
//承运商服务仓库分页查询
export const HttpCarrierServiceWareList = (data = {}) => HttpService.get('/api/v2/SystemDeliveryCarrier/findWarehouseId', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })
//承运商服务配置保存
export const HttpSaveCarrierService = (data = {}) => HttpService.post('/api/v2/SystemDeliveryCarrier/saveOne', data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_FBB })
//承运商服务配置导出
export const HttpExportCarrierService = (data = {}, config) => HttpService.get('/api/v2/SystemDeliveryCarrier/export', { ...config, params: data, baseURL: process.env.VUE_APP_APIURL_FBB })

//查看客户合同管理列表
export const HttpGetCusContactList = (data = {}) => HttpService.get("/api/v2/customerContract/findByPage", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
//查看合同详情
export const HttpQueryCusContactOne = (data = {}) => HttpService.get("/api/v2/customerContract/detail", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
//客户合同删除
export const HttpDeleteCusContactPort = (data = {}) => HttpService.post('/api/v2/customerContract/deleteById', data, { baseURL: process.env.VUE_APP_APIURL_FBB })
//客户合同保存
export const HttpSaveCusContact = (data = {}) => HttpService.post('/api/v2/customerContract/save', data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_FBB })
//客户合同上传附件
export const HttpUploadCusContactAttach = (data = {}) => HttpService.post('/api/v2/customerContract/addAttach', data, { baseURL: process.env.VUE_APP_APIURL_FBB })
//客户合同删除附件
export const HttpDeleteCusContactAttach = (data = {}) => HttpService.post('/api/v2/customerContract/deleteAttach', data, { baseURL: process.env.VUE_APP_APIURL_FBB })

// 获取仓库承运商下拉
export const HttGetwarehouseCarrierList = (data = {}) => HttpService.post('/api/v2/customerContract/warehouseCarrierList', data, { baseURL: process.env.VUE_APP_APIURL_FBB })

// 组织服务配置
//组织发运分页查询
export const HttpOrgServiceList = (data = {}) => HttpService.get('/api/v2/orgCarrierService/findByPage', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })
//承运商服务分页查询
export const HttpOrgCarrierService = (data = {}) => HttpService.get('/api/v2/orgCarrierService/findCarrierService', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })
//仓库列表分页查询
export const HttpOrgWarehouseService = (data = {}) => HttpService.get('/api/v2/orgCarrierService/findWarehouseId', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })
//承运商服务配置保存
export const HttpSaveOrgService = (data = {}) => HttpService.post('/api/v2/orgCarrierService/saveOne', data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_FBB })
// 组织下对应可用仓库
export const HttpOrgServiceWarehouseList = (data = {}) => HttpService.get('/api/v2/warehouse/findAllByOrgId', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })
export const HttpServiceWarehouseList = (data = {}) => HttpService.get('/api/v2/warehouse/findByOrgIdAndActive', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })


// 仓库承运商配置
// 列表，查看，创建，编辑
export const HttpGetAccountList = (data = {}) => HttpService.post('/api/v2/WarehouseCarrier/findByPage', data, { baseURL: process.env.VUE_APP_APIURL_FBB })

export const HttpQueryAccountOne = (data = {}) => HttpService.get("/api/v2/WarehouseCarrier/detail", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });

export const HttpCreateAccountOne = (data = {}) => HttpService.post("/api/v2/WarehouseCarrier/save", data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_FBB });

export const HttpSaveAccountOne = (data = {}) => HttpService.post("/api/v2/WarehouseCarrier/edit", data, { baseURL: process.env.VUE_APP_APIURL_FBB });

// 虚拟仓的接口
export const HttpVirtualWarehouse = (data = {}) => HttpService.get("/api/v2/organizationWarehouse/findVirtualOrgWarehousesByOrgId", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });

// 进口商分页查询
export const HttpGetImporterList = (data) => HttpService.get('/api/v2/importer/query', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });

// 港口分页查询
export const HttpGetSystemPortList = (data) => HttpService.get('/api/v2/systemPort/query', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });

// 获取货代公司
export const HttpGetCompany = (data) => HttpService.get('/api/v1/Organization/selectByFilters', { params: data, baseURL: process.env.VUE_APP_APIURL_UC });


// 仓库列表列表、查看
export const HttpGetWarehouseList = (data = {}) => HttpService.get('/api/v2/organizationWarehouse/findAllByPage', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
export const HttpGetWarehouseOne = (data = {}) => HttpService.get("/api/v2/organizationWarehouse/findDetailById", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
//TMS货代港口管理
export const HttpSaveForwarderPort = (data = {}) => HttpService.post('/api/v2/forwarderPort/saveAndUpdate', data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_FBB })

export const HttpForwarderPortList = (data) => HttpService.get('/api/v2/forwarderPort/query', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });

export const HttpDeleteForwarderPort = (data) => HttpService.get('/api/v2/forwarderPort/delete', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });

export const HttpForwarderPortGetOne = (data = {}) => HttpService.get("/api/v2/forwarderPort/detail", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });

//TMS系统港口管理
export const HttpSaveSystemPort = (data = {}) => HttpService.post('/api/v2/systemPort/saveAndUpdate', data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_FBB })

export const HttpSystemPortList = (data) => HttpService.get('/api/v2/systemPort/query', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });

export const HttpDeleteSystemPort = (data) => HttpService.get('/api/v2/systemPort/delete', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });

export const HttpSystemPortGetOne = (data = {}) => HttpService.get("/api/v2/systemPort/detail", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });

//门店管理
export const HttpSaveGateShop = (data = {}) => HttpService.post('/api/v2/address/saveAndUpdate', data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_FBB })

export const HttpAddressesList = (data) => HttpService.get('/api/v2/address/query', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });

export const HttpGateShopGetOne = (data = {}) => HttpService.get("/api/v2/address/detail", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });

//区域管理
export const HttpAreaList = (data) => HttpService.get('/api/v2/areaManage/findByPage', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });

export const HttpGetWarehouseCustomerList = (data = {}) => HttpService.get("/api/v2/warehouse/findByPage", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
// 仓库线下订单
export const HttpGetWarehouseOfflineList = (data = {}) => HttpService.get('/api/v2/offlineOrder/findByPage', { params: data });
// 查询所有承运服务
export const HttpGetAllCarrierService = (data = {}) => HttpService.get("/api/v2/carrierVolumeWeight/findDeliveryCarrier", { params: data });
// 添加
export const HttpAddOfflineOrder = (data = {}) => HttpService.post("/api/v2/offlineOrder/create", data);
// 启用失效
export const HttpUpdateStatus = (data = {}) => HttpService.post("/api/v2/offlineOrder/active", data);

export const HttpGetWarehouseCustomerOne = (data = {}) => HttpService.get("/api/v2/organizationWarehouse/findDetailById", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
export const HttpAreaGetOne = (data = {}) => HttpService.get("/api/v2/areaManage/detail", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
export const HttpSaveArea = (data = {}) => HttpService.post("/api/v2/areaManage/saveAndUpdate", data, { baseURL: process.env.VUE_APP_APIURL_FBB });

export const HttChangeActive = (data = {}) => HttpService.post("/api/v2/areaManage/changeActive", data, { baseURL: process.env.VUE_APP_APIURL_FBB });

export const HttpSaveWarehouseCustomerOne = (data = {}) => HttpService.post("/api/v2/warehouse/warehouseSettingOrg", data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_FBB })


// 客户仓库分配列表、查看、保存
export const HttpGetCustomerWarehouseList = (data = {}) => HttpService.get('/api/v2/organizationWarehouse/findWarehouseByPage', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });

export const HttpGetCustomerWarehouseOne = (data = {}) => HttpService.post('/api/v2/organizationWarehouse/getDetailByOrg', data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 仓库线下订单详情&日志
export const HttpOfflineOrderLog = (data = {}) => HttpService.get("/api/v2/offlineOrder/detail", { params: data });

export const HttpSaveCustomerWarehouseOne = (data = {}) => HttpService.post("/api/v2/organizationWarehouse/orgWarehouseSettingParam", data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_FBB })

// 仓库列表
export const HttpWarehouseListGetList = (data = {}) => HttpService.get("/api/v2/organizationWarehouse/findListByPage", { params: data });
// 仓库列表详情
export const HttpWarehouseListGetDetail = (data = {}) => HttpService.get("/api/v2/organizationWarehouse/findOne", { params: data });
// 编辑仓库配置
// export const HttpWarehouseListEditConfig = (data = {}) => HttpService.post("/api/v2/organizationWarehouse/scpEnable", data);
export const HttpWarehouseListEditConfig = (data = {}) => HttpService.post("/api/v2/organizationWarehouse/update", data, { headers: { "Content-Type": "application/json" } });
//删除附件
export const HttpWarehouseListDeleteAttaches = (data = {}) => HttpService.get("/api/v2/warehouse/deleteAttach", { params: data });
//仓库预约量配置——>批量修改
export const HttpWarehouseListBathUpdate = (data = {}) => HttpService.post("/api/v2/ReserveWarehouseCfg/batchUpdate", data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_FBB });

